import kebabCase from 'lodash.kebabcase'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { navigationLinks } from '../helper'

type ReturnType = {
  showTop: boolean
  setShowTop: Dispatch<SetStateAction<boolean>>
}

export const useSideBarLocation = (): ReturnType => {
  const location = useLocation()
  const [showTop, setShowTop] = useState(false)

  const visibleLocation = navigationLinks
    .map(kebabCase)
    .map(title => `#${title}`)

  useEffect(() => {
    visibleLocation.find(item => item === location.hash)
      ? setShowTop(false)
      : setShowTop(true)
  }, [location, visibleLocation])

  return { showTop, setShowTop }
}
